import { Button, Col, Form, Modal } from "react-bootstrap";
import styles from "./pedidos_style.module.css"
import InsumosPedidoStatus from "./PedidoStatus";
import dayjs from "dayjs";
import InsumosPedidoTabelaProdutos from "./TabelaProdutos";
import { useEffect, useState } from "react";
import { getElementFromId } from "../../../components/funcForInput";
import { ApiEndpoints, reqPatch, reqPostDownloadFile, reqPostNew } from "../../../config/apiClient";
import { toast } from "react-toastify";
import funcSleep from "../../../components/funcSleep";
import removeAllErrorMsg from "../../../components/funcRemoveAllErros";
import InsumosBtnLoading from "./BtnLoading";
import { getCookie } from "../../../config/cookies";
import { getUrlSearchParams } from "../../urlParams";

export default function InsumosModalPedido({ show, _pedido, filtrosDados, handleClose, unidadesOptions, produtosOptions, onUpdate }: iProps) {

    const [btnIdClick, setBtnIdClick] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)
    const [pedido, setPedido] = useState<any>(_pedido)
    const [listaProdutos, setListaProdutos] = useState<any[]>(handleParseListaProdutos(_pedido.produtos))
    const [showBtnDeletar, setShowBtnDeletar] = useState<boolean>(true)

    useEffect(() => {
        const handleClick = (e:any) => {
            if (e.target.tagName === "BUTTON") {
                // console.log(e.target.id)
                setBtnIdClick(e.target.id)
            }
        };
        document.addEventListener("click", handleClick)

        if (Object.values(pedido).length > 0) {
            const data_atual = dayjs()
            const data_criacao = dayjs(pedido.data_criacao)
            if (data_atual.diff(data_criacao, 'days') > 45 && pedido.id_status.id_status !== 1) { 
                setShowBtnDeletar(false)
            }

            revisarPedidoViaUrl()
        }
        // eslint-disable-next-line
    }, [])
    function revisarPedidoViaUrl() {
        let urlParams:URLSearchParams = getUrlSearchParams()
        const id_action = urlParams.get("action")
        if (id_action !== null) {
            const id_status_revisao = Number(id_action)
            if (id_status_revisao === 2) {
                revisar(2, "aprovar", false)
            }
            if (id_status_revisao === 3) {
                revisar(3, "reprovar", false)
            }
            window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA SISTEMA INSUMOS", `/insumos/pedidos?id=${pedido.id_pedido}`)
        }
    }

    function handleParseListaProdutos(produtos: any[]) {
        let dados: any[] = []
        for (let prod of produtos) {
            dados.push({
                id: prod.id,
                id_pedido: pedido.id_pedido,
                id_produto: prod.id_produto.id_produto,
                id_unidade: prod.id_unidade.id_unidade,
                qtd: prod.qtd,
            })
        }
        return dados
    }

    function handleChangeListaProdutos(dados: any[]) {
        setListaProdutos(dados)
    }

    async function handleSalvarListaProdutos() {
        removeAllErrorMsg()
        if (loading) {
            return
        }
        let formValidado = true
        let dadosForm = {
            id_pedido: pedido.id_pedido,
            produtos: listaProdutos,
        }
        let possui_prod_duplicado = false
        for (let idx in dadosForm.produtos) {
            let prod = dadosForm.produtos[idx]
            if (prod.qtd <= 0) {
                let inputQtd = getElementFromId(`${idx}-qtd`)
                inputQtd.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (prod.id_produto === 0) {
                let inputProd = getElementFromId(`${idx}-id_produto_aux`)
                inputProd.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (prod.id_unidade === 0) {
                let inputUnid = getElementFromId(`${idx}-id_unidade_aux`)
                inputUnid.nextElementSibling.style.display = "block"
                formValidado = false
            }
            let qtd_encontrado = 0
            for (let prodaux of dadosForm.produtos) {
                if (prodaux.id_produto === prod.id_produto && prodaux.id_unidade === prod.id_unidade) {
                    qtd_encontrado += 1
                }
            }
            if (qtd_encontrado > 1) {
                possui_prod_duplicado = true
            }
        }
        if (possui_prod_duplicado) {
            window.alert("Verifique a lista, existem produtos duplicados!")
            formValidado = false
        }
        if (dadosForm.produtos.length === 0) {
            window.alert("Lista de produtos está vazia!")
            formValidado = false
        }

        if (!formValidado) {
            return
        }

        editar(dadosForm)
    }

    async function editar(dados: any) {
        setLoading(true)
        const api = await reqPatch(ApiEndpoints.insumosEditarProdutosPedido, dados)
        if (api.status === 200) {
            toast.success('Lista de Produtos editado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            setPedido(api.data)
            onUpdate()
            await funcSleep(500)
        }
        setLoading(false)
    }
    async function revisar(id_status: number, status: "aprovar" | "reprovar" | "pendente", confirmar: boolean) {
        let status_mensagem = ""
        switch (status) {
            case 'aprovar':
                status_mensagem = "aprovado"
            break;
            case 'reprovar':
                status_mensagem = "reprovado"
            break;
            case 'pendente':
                status_mensagem = "pendente"
            break;
        }
        if (confirmar) {
            if (id_status === 1) {
                if (!window.confirm(`Tem certeza que deseja resetar o status?`)) {
                    return
                }
            } else {
                if (!window.confirm(`Tem certeza que deseja ${status} o pedido?`)) {
                    return
                }
            }
        }
        
        let dados = {
            id_usuario: Number(getCookie("id_user")),
            id_pedido: pedido.id_pedido,
            id_status: id_status,
        }
        setLoading(true)
        const api = await reqPatch(ApiEndpoints.insumosRevisarPedido, dados)
        if (api.status === 200) {
            toast.success(`Status do pedido alterado com sucesso para ${status_mensagem}!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            setPedido(api.data)
            onUpdate()
            await funcSleep(500)
        }
        setLoading(false)
    }
    async function downloadRelatorio() {
        const dados = {
            id_pedido: pedido.id_pedido
        }
        setLoading(true)
        let arquivo:string = `REQUISIÇÃO DE PRODUTOS DO ALMOXARIFADO PARA ${pedido.id_local.descricao} ${dayjs().format("DD-MM-YYYY")}.docx`
        let response = await reqPostDownloadFile(ApiEndpoints.insumosDownloadRelatorio, dados, arquivo)
        if (response.status === 200) {
            toast.success('Aguarde o termino do download...', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        } else {
            toast.error('Erro no download, tente mais tarde ou verifique com o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        setLoading(false)
    }
    async function deletar() {
        if (!window.confirm("Tem certeza que deseja excluir o pedido?")) {
            return
        }
        const dados = {
            id_pedido: pedido.id_pedido
        }
        setLoading(true)
        const api = await reqPostNew(ApiEndpoints.insumosDeletarPedido, dados)
        if (api.status === 200) {
            toast.success(`Pedido deletado com sucesso!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            onUpdate()
            handleClose()
            await funcSleep(500)
        }
        setLoading(false)
    }

    return (
        <Modal
            id={styles.modal_insumo_pedido}
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={true}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Insumos FAI - Pedido</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InsumosPedidoStatus pedido={pedido} />
                <br></br>
                <div className="div-row" style={{ alignItems: "start" }}>
                    <Col className="col-4">
                        <Form.Group>
                            <Form.Label>#ID Pedido:</Form.Label>
                            <Form.Control type="text" name="id_pedido" id="id_pedido" disabled={true} defaultValue={pedido.id_pedido} />
                        </Form.Group>
                        <br></br>
                        <Form.Group>
                            <Form.Label>Criado em:</Form.Label>
                            <Form.Control type="text" name="data_criacao" id="data_criacao" disabled={true} defaultValue={dayjs(pedido.data_criacao).format("DD/MM/YYYY - HH:mm")} />
                        </Form.Group>
                        <br></br>
                        <Form.Group>
                            <Form.Label>Local:</Form.Label>
                            <Form.Control type="text" name="local" id="local" disabled={true} defaultValue={pedido.id_local.descricao} />
                        </Form.Group>
                        <br></br>
                        <Form.Group>
                            <Form.Label>Colaborador:</Form.Label>
                            <Form.Control type="text" name="colaborador" id="colaborador" disabled={true} defaultValue={`#${pedido.id_colaborador.matricula} - ${pedido.id_colaborador.nome_completo}`} />
                        </Form.Group>
                        <br></br>
                        <Form.Group>
                            <Form.Label>Observação:</Form.Label>
                            <Form.Control as="textarea" rows={8} maxLength={1000} name='observacao' id='observacao' autoComplete='off' disabled={true} defaultValue={pedido.observacao} />
                        </Form.Group>
                        <br></br>
                    </Col>
                    <Col className="col-8" style={{ margin: "0px 10px" }}>
                        <InsumosPedidoTabelaProdutos id_pedido={pedido.id_pedido} filtrosDados={filtrosDados} pedido={pedido} produtos={listaProdutos} btnIdClick={btnIdClick} unidadesOptions={unidadesOptions} produtosOptions={produtosOptions} onChange={handleChangeListaProdutos} onSave={handleSalvarListaProdutos} loading={loading} />
                    </Col>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ width: "100%" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    {
                        pedido.id_status.id_status === 1 &&
                        <div>
                            <Button id="btnAprovarPedido" variant="success" onClick={() => { revisar(2, "aprovar", true) }} style={{ marginRight: "5px" }}><InsumosBtnLoading btnId="btnAprovarPedido" btnIdClick={btnIdClick} loading={loading} /> APROVAR</Button>
                            <Button id="btnReprovarPedido" variant="danger" onClick={() => { revisar(3, "reprovar", true) }} style={{ marginRight: "5px" }}><InsumosBtnLoading btnId="btnAprovarPedido" btnIdClick={btnIdClick} loading={loading} /> REPROVAR</Button>
                            { showBtnDeletar && <Button id="btnDeletarPedido" variant="secondary" onClick={() => { deletar() }} style={{ marginRight: "5px" }}><InsumosBtnLoading btnId="btnDeletarPedido" btnIdClick={btnIdClick} loading={loading} /> DELETAR</Button> }
                        </div>
                    }
                    {
                        pedido.id_status.id_status === 2 &&
                        <div>
                            <Button id="btnDownloadRelatorioPedido" variant="success" onClick={() => { downloadRelatorio() }} style={{ marginRight: "5px" }}><InsumosBtnLoading btnId="btnDownloadRelatorioPedido" btnIdClick={btnIdClick} loading={loading} /> Download Relatório</Button>
                            <Button id="btnReabrirPedido" variant="primary" onClick={() => { revisar(1, "pendente", true) }} style={{ marginRight: "5px" }}><InsumosBtnLoading btnId="btnReabrirPedido" btnIdClick={btnIdClick} loading={loading} /> REABRIR</Button>
                            { showBtnDeletar && <Button id="btnDeletarPedido" variant="secondary" onClick={() => { deletar() }} style={{ marginRight: "5px" }}><InsumosBtnLoading btnId="btnDeletarPedido" btnIdClick={btnIdClick} loading={loading} /> DELETAR</Button> }
                        </div>
                    }
                    {
                        pedido.id_status.id_status > 2 &&
                        <div>
                            <Button id="btnReabrirPedido" variant="primary" onClick={() => { revisar(1, "pendente", true) }} style={{ marginRight: "5px" }}><InsumosBtnLoading btnId="btnReabrirPedido" btnIdClick={btnIdClick} loading={loading} /> REABRIR</Button>
                            { showBtnDeletar && <Button id="btnDeletarPedido" variant="secondary" onClick={() => { deletar() }} style={{ marginRight: "5px" }}><InsumosBtnLoading btnId="btnDeletarPedido" btnIdClick={btnIdClick} loading={loading} /> DELETAR</Button> }
                        </div>
                    }
                    <div>
                        <Button variant="secondary" onClick={handleClose}>Fechar</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    )
}
interface iProps {
    show: boolean
    _pedido: any
    filtrosDados: any
    handleClose: any
    unidadesOptions: any[]
    produtosOptions: any[]
    onUpdate: any
}
